import React, { Fragment } from 'react';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { IconButton, Flex, Text } from 'onefaceui-react-components';
import PropTypes from 'prop-types';
import {
  stopStatusIcons,
  clonedStopStatusIcons,
  orderAndItemsIcon,
  photoAlbumsIcon,
  smartSurveyIcon
} from 'react/utils/stopDetailsPopupBase64Icons.js';

import * as actions from 'react/api/actions/stopDetailsPopup';
import Rating from 'react/components/monet/fields/rating.jsx';
import IconWithNumber from 'react/components/IconWithNumber';
import Loading from 'react/components/Loading'
import ScrollableContent from 'react/components/RouteDetails/ScrollableContent';

import ActionButtons from './actionButtons/ActionButtons.jsx';
import StopDetailsPopupAccordion from './StopDetailsPopupAccordion.jsx';
import StopDetailsInfoAccordion from './StopDetailsInfoAccordion.jsx';
import ServiceTimeType from './ServiceTimeType.jsx';
import Reason from './Reason.jsx';
import { actionCreators as actionSurveyModal } from 'react/api/actions/routeSurveyModal';
import { actionCreators as actionsModals } from 'react/api/actions/modals';
import { PHOTO_ALBUM_MODAL_KEY } from 'react/containers/modals/PhotoAlbumModal/PhotoAlbumModal.jsx';

import OrderAndItemsModal from 'react/containers/modals/OrderAndItemsModal';
import RouteSurveyModal from 'react/containers/modals/RouteSurveyModal';
import { secondaryBackgroundColor, whiteTextsColor, fontFamily, secondaryTextColor } from './colorsAndFonts';
import { checkPermissions, getResourceTo } from 'react/utils/utils'


const scrollableContent = {
  height: '100%',
  body: {
    padding: '0px 10px',
  }
};

const popupContainerStyle = {
  overflow: 'auto',
  minWidth: '455px',
  display: 'flex',
  flexDirection: 'column',
  color: whiteTextsColor,
  position: 'absolute',
  top: '34px',
  bottom: '5px',
  left: '0px',
  paddingBottom: '10px'
};

const loadingContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  flex: '1 1 auto'
};

const descriptionStyle = {
  row: {
    base: {
      backgroundColor: secondaryBackgroundColor,
      paddingBottom: '10px',
      borderBottom: 'none'
    },
    contentLeft: {
      flexGrow: '0',
      marginRight: '16px'
    },
    contentRight: {
      alignItems: 'flex-start'
    }
  },
  icon: {
    width: '50px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  fullDescription: {
    fontFamily,
    fontWeight: 'bold',
    fontSize: '14px',
    color: whiteTextsColor,
    marginTop: '14px'
  },
  address: {
    fontFamily,
    fontWeight: 'normal',
    fontSize: '12px'
  },
  email: {
    fontFamily,
    fontWeight: 'normal',
    fontSize: '12px',
    marginTop: '2px'
  },
  stopStatus: {
    display: 'flex',
    alignItems: 'center',
    icon: (base64) => ({
      display: 'inline-flex',
      width: '15px',
      height: '15px',
      background: `var(${base64})`
    }),
    title: {
      fontFamily,
      fontWeight: 'normal',
      fontSize: '12px',
      color: whiteTextsColor,
      margin: '0 0 0 5px',
      display: 'inline-flex'
    }
  }
};

const buttonWithIconStyle = {
  icon: {
    width: '22px',
    height: '22px',
  },
  label: {
    fontFamily,
    margin: 0,
    color: secondaryTextColor,
    fontSize: "12px"
  }
};

const stopStatusDescriptions = {
  PENDING: 'Greenmile.Stop.IconDescription.pending',
  DELIVERED: 'Greenmile.Stop.IconDescription.completed',
  REDELIVERED: 'Greenmile.Stop.IconDescription.redelivery',
  UNDELIVERED: 'Greenmile.Stop.IconDescription.undeliverable',
  CANCELED: 'Greenmile.Stop.IconDescription.cancel',
  IN_PROGRESS: 'Greenmile.Stop.IconDescription.inProgress',
  PARTIALLY_DELIVERED: 'Greenmile.Stop.IconDescription.partiallyDelivered'
};

class StopDetailsPopup extends React.Component {
  state = {
    orderAndItemIsOpen: false
  };

  componentDidMount = () => {
    this.requestStopDetailsPopupData();
    this.galleryInstance = new Greenmile.Gallery.Picture();
  }

  componentWillUnmount = () => {
    const { cancelGeocodeAction, routeId, stopId } = this.props;
    cancelGeocodeAction(routeId, stopId);
  }

  toggleOrderAndItemsModal = () => {
    const { routeId } = this.props;

    const selector = `RouteDetails_${routeId}`;
    this.galleryInstance.closeModal(selector);

    this.setState({
      orderAndItemIsOpen: !this.state.orderAndItemIsOpen
    });
  }

  handleSurveyAnswersModal = () => {
    const { routeId, stopId, openSurveysModal } = this.props;

    const selector = `RouteDetails_${routeId}`;
    this.galleryInstance.closeModal(selector);

    openSurveysModal({
      routeId: String(routeId),
      stopId: String(stopId)
    });
  }

  handlePhotoAlbumsModal = () => {
    const { routeId, stopId, openModal, stop } = this.props;

    openModal({
      modalKey: PHOTO_ALBUM_MODAL_KEY,
      data: {
        stopId,
        routeId,
        entity: "stop",
        key: stop.get('key')
      }
    });
  }

  requestStopDetailsPopupData = () => {
    const {
      routeId, stopId, marker, map, requestStopDetailsPopupDataAction
    } = this.props;
    requestStopDetailsPopupDataAction(routeId, stopId, marker, map);
  }

  renderDescription = () => {
    const { stop } = this.props;
    const itemsOfAddress = ['addressLine1', 'addressLine2', 'district', 'zipCode', 'city', 'state', 'country'];
    const stopStatus = stop.get('status');
    const deliveryStatus =
      stopStatus === 'CANCELED' ? stopStatus : stop.get('deliveryStatus');
    const cloneDate = stop.get('cloneDate');
    const statusIcons = cloneDate ? clonedStopStatusIcons : stopStatusIcons;
    const key = stop.getIn(['location', 'key'], '');
    const description = stop.getIn(['location', 'description'], '');
    const fullDescription = `${key} - ${description}`;
    const plannedSequenceNum = stop.get('plannedSequenceNum');

    const phone1 = stop.getIn(['location', 'phone1'], '');
    const phone2 = stop.getIn(['location', 'phone2'], '');
    const email = stop.getIn(['location', 'email'], '');

    const address = itemsOfAddress.reduce((acc, curr) => {
      const value = stop.getIn(['location', `${curr}`]);
      if (value) {
        acc += (acc) ? `, ${value}` : value;
      }
      return acc;
    }, '');

    const iconStatusBase64 = statusIcons[deliveryStatus];
    const stopStatusTitle = Monet.I18n.getResourcesByKey(
      stopStatusDescriptions[deliveryStatus]
    );

    return (
      <Flex
        alignItems="center"
        gap={16}
        style={{
          padding: '0 10px 10px 10px'
        }}
      >
        <IconWithNumber
          numberLabel={plannedSequenceNum}
          iconUrl={iconStatusBase64}
          style={descriptionStyle.icon}
          title={stopStatusTitle}
        />
        <div>
          <div
            data-testid="stop-description"
            style={descriptionStyle.fullDescription}
          >
            {fullDescription}
          </div>
          <div data-testid="stop-address" style={descriptionStyle.address}>
            {address}
          </div>
          {(phone1 || phone2) && (
            <div className="phone-container">
              {phone1 && (
                <div className="phone1">
                  <span />
                  <p data-testid="stop-phone1">{phone1}</p>
                </div>
              )}
              {phone2 && (
                <div className="phone2">
                  <span />
                  <p data-testid="stop-phone2">{phone2}</p>
                </div>
              )}
            </div>
          )}
          <div data-testid="stop-email" style={descriptionStyle.email}>
            {email}
          </div>
          <div style={descriptionStyle.stopStatus}>
            <i
              style={descriptionStyle.stopStatus.icon(iconStatusBase64)}
              title={stopStatusTitle}
            />
            <p style={descriptionStyle.stopStatus.title}>{stopStatusTitle}</p>
          </div>
        </div>
      </Flex>
    );
  }

  renderDescriptionBottom = () => {
    const { stop } = this.props;

    const plannedSequenceNum = stop.get('plannedSequenceNum');
    const actualSequenceNum = stop.get('actualSequenceNum');
    const rating = stop.get('rating', '0');

    return (
      <Flex
        alignItems="center"
        style={{
          padding: '0 10px 10px 10px'
        }}
      >
        <div className="description-content-bottom">
          <Flex className="label-with-value" flexDirection="column">
            <Text size="xs" type="neutral">{getResourceTo('Stop.popup.plannedSequence')}</Text>
            <Text size="xs" dataTestId="plannedSequence">{plannedSequenceNum}</Text>
          </Flex>
          <Flex className="label-with-value" flexDirection="column">
            <Text size="xs" type="neutral">{getResourceTo('Stop.popup.actualSequence')}</Text>
            <Text size="xs" dataTestId="actualSequence">{actualSequenceNum}</Text>
          </Flex>
          <Flex className="label-with-value" flexDirection="column" shouldShow={checkPermissions("ROUTEDETAIL_EVALUATION")}>
            <Text size="xs" type="neutral">{getResourceTo('Stop.popup.deliveryEvaluation')}</Text>
            <Rating value={rating} />
          </Flex>
          <Flex
            className="label-with-button"
            flexDirection="column"
            alignItems="center"
          >
            <Text size="xs" type="neutral">{getResourceTo('Stop.popup.ordersAndItems')}</Text>
            <IconButton dataTestId="button-with-icon-order-and-items" onClick={this.toggleOrderAndItemsModal}>
              <img style={buttonWithIconStyle.icon} src={orderAndItemsIcon} />
            </IconButton>
          </Flex>
          <Flex
            className="label-with-button"
            flexDirection="column"
            alignItems="center"
            shouldShow={checkPermissions("PHOTOALBUM_LIST")}
          >
            <Text size="xs" type="neutral">{getResourceTo('Stop.popup.photoAlbums')}</Text>
            <IconButton dataTestId="button-with-icon-photo-albums" onClick={this.handlePhotoAlbumsModal}>
              <img style={buttonWithIconStyle.icon} src={photoAlbumsIcon} />
            </IconButton>
          </Flex>
          <Flex
            className="label-with-button"
            flexDirection="column"
            alignItems="center"
            shouldShow={checkPermissions("SURVEY_LIST")}
          >
            <Text size="xs" type="neutral">{getResourceTo('Stop.popup.stopSurveys')}</Text>
            <IconButton dataTestId="button-with-icon-stop-surveys" onClick={this.handleSurveyAnswersModal}>
              <img style={buttonWithIconStyle.icon} src={smartSurveyIcon} />
            </IconButton>
          </Flex>
        </div>
      </Flex>
    );
  }

  getModalSurveyContainer = () => {
    const { routeId } = this.props;

    let container = document.querySelector(`#routeMaps_${routeId} #stopDetailsSurveyModal`);

    if (!container) {
      container = document.createElement('div');
      container.id = `stopDetailsSurveyModal`;

      document.querySelector(`#routeMaps_${routeId}`).appendChild(container);
    }

    return container;
  }

  render() {
    const {
      routeId,
      stopId,
      isLoadingData,
      marker,
      map,
      stop,
      hasGeocodeCreatePermission,
      hasGeocodeListPermission,
      hasEditLocationPermission
    } = this.props;

    const { orderAndItemIsOpen } = this.state;

    return (
      <>
        <RouteSurveyModal
          routeId={Number(routeId)}
          stopId={Number(stopId)}
          parentSelector={() => this.getModalSurveyContainer()}
          title={Monet.I18n.getResourcesByKey('stopSurveyModal.title')}
          subtitle={Monet.I18n.getResourcesByKey('stopSurveyModal.subtitle')}
        />
        {orderAndItemIsOpen && <OrderAndItemsModal
          stopId={stopId}
          isOpen={orderAndItemIsOpen}
          idScreen={`RouteDetails_${routeId}`}
          closeAction={() => {
            this.toggleOrderAndItemsModal()
          }}
        />}
        <div data-testid="stop-details-popup" style={popupContainerStyle}>
          {isLoadingData && (
            <div style={loadingContainerStyle}>
              <Loading height="50px" width="50px" />
            </div>
          ) || (
            <Fragment>
              <div data-testid="stop-details-popup-content">
                {this.renderDescription()}
                {this.renderDescriptionBottom()}
                <Flex
                  alignItems="center"
                  className="action-buttons"
                >
                  <ActionButtons
                    hasGeocodeListPermission={hasGeocodeListPermission}
                    hasGeocodeCreatePermission={hasGeocodeCreatePermission}
                    hasEditLocationPermission={hasEditLocationPermission}
                    routeId={routeId}
                    stopId={stopId}
                    marker={marker}
                    map={map}
                  />
                </Flex>
              </div>
              <ScrollableContent style={scrollableContent}>
                <ServiceTimeType routeId={routeId} stopId={stopId} stop={stop} />
                <Reason routeId={routeId} stopId={stopId} stop={stop} />
                <StopDetailsInfoAccordion routeId={routeId} stopId={stopId} stop={stop} />
                <StopDetailsPopupAccordion routeId={routeId} stopId={stopId} stop={stop} />
              </ScrollableContent>
            </Fragment>
            )
          }
          </div>
      </>
    );
  }
}

StopDetailsPopup.propTypes = {
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stop: PropTypes.object.isRequired,
  map: PropTypes.object.isRequired,
  marker: PropTypes.object.isRequired,
  cancelGeocodeAction: PropTypes.func.isRequired,
  openSurveysModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  requestStopDetailsPopupDataAction: PropTypes.func.isRequired,
  isLoadingData: PropTypes.bool.isRequired,
  hasTimeWindows: PropTypes.bool,
  hasGeocodeCreatePermission: PropTypes.bool.isRequired,
  hasGeocodeListPermission: PropTypes.bool.isRequired,
  hasEditLocationPermission: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({
  stop: stopDetailsPopup.getIn([String(routeId), String(stopId), 'stop'], Map({})),
  isLoadingData: stopDetailsPopup.getIn([String(routeId), String(stopId), 'isLoadingData'], true)
});

const mapDispatchToProps = {
  cancelGeocodeAction: actions.cancelGeocode,
  requestStopDetailsPopupDataAction: actions.requestStopDetailsPopupData,
  openSurveysModal: actionSurveyModal.open,
  openModal: actionsModals.openModal
};

export default connect(mapStateToProps, mapDispatchToProps)(StopDetailsPopup);
